import React, { useEffect } from "react";
import { Instagram, ArrowUpRight } from "lucide-react";
import { CONTACT } from "../../lib/constants";
import { useLanguage } from "../../contexts/LanguageContext";
import { useReveal } from "../../hooks/useReveal";

const ELFSIGHT_SRC = "https://elfsightcdn.com/platform.js";
const WIDGET_CLASS = "elfsight-app-545a0231-1797-4583-8175-52e4685c7ba9";

const COPY = {
  en: {
    overline: "Latest from the feed",
    title: "Follow along on Instagram.",
    subtitle:
      "Fresh sessions, behind-the-scenes moments and everyday inspiration — updated straight from @click90photography.",
    cta: "Follow @click90photography",
  },
  gr: {
    overline: "Πρόσφατα από το feed",
    title: "Ακολουθήστε μας στο Instagram.",
    subtitle:
      "Πρόσφατες φωτογραφίσεις, στιγμές από τα παρασκήνια και καθημερινή έμπνευση — απευθείας από το @click90photography.",
    cta: "Ακολουθήστε @click90photography",
  },
};

export const InstagramFeed = () => {
  const { lang } = useLanguage();
  const c = COPY[lang] || COPY.en;
  const ref = useReveal();

  useEffect(() => {
    // Load Elfsight platform script once
    if (document.querySelector(`script[src="${ELFSIGHT_SRC}"]`)) return;
    const script = document.createElement("script");
    script.src = ELFSIGHT_SRC;
    script.async = true;
    document.body.appendChild(script);
  }, []);

  return (
    <section
      id="instagram"
      data-testid="instagram-section"
      className="bg-bg-alt py-16 md:py-20"
    >
      <div ref={ref} className="reveal max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row items-start md:items-end justify-between gap-8 mb-14">
          <div className="max-w-2xl">
            <p className="overline">{c.overline}</p>
            <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl text-accent-dark mt-4 tracking-tight font-light leading-[1.1]">
              {c.title}
            </h2>
            <p className="mt-5 text-text-muted text-base md:text-lg leading-relaxed">
              {c.subtitle}
            </p>
          </div>
          <a
            href={CONTACT.instagram}
            target="_blank"
            rel="noreferrer"
            data-testid="instagram-follow"
            className="inline-flex items-center gap-2 text-[11px] tracking-[0.2em] uppercase font-medium text-accent-dark hover:text-gold transition-colors border-b border-accent-dark hover:border-gold pb-1"
          >
            <Instagram size={14} /> {c.cta} <ArrowUpRight size={14} />
          </a>
        </div>

        <div
          data-testid="instagram-widget"
          className={WIDGET_CLASS}
          data-elfsight-app-lazy
        />
      </div>
    </section>
  );
};
